import React, { CSSProperties } from 'react';
import styled from 'styled-components';

import { ReactComponent as LoadingIcon } from 'app/images/loading.svg';

const Wrapper = styled.div`
  position: absolute;
  display: flex;
  width: 60px;
  height: 60px;
  z-index: 10;
  right: 0;
`;

const Spinner = styled(LoadingIcon)`
  width: 24px;
`;

const Pace = ({ style }: { style?: CSSProperties }) => {
  return (
    <Wrapper style={style}>
      <Spinner />
    </Wrapper>
  );
};

export default Pace;
